import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, DetachedRouteHandle, RouteReuseStrategy } from '@angular/router';

@Injectable()
export class CustomRouteReuseStrategy implements RouteReuseStrategy {
  public shouldDetach(): boolean {
    return false;
  }

  public store(): void {}

  public shouldAttach(): boolean {
    return false;
  }

  public retrieve(): DetachedRouteHandle | null {
    return null;
  }

  public shouldReuseRoute(future: ActivatedRouteSnapshot, curr: ActivatedRouteSnapshot): boolean {
    return future.data?.reload ? false : future.routeConfig === curr.routeConfig;
  }
}
